export default {
  SEARCH_CATALOG_KUSPIT_BUSINESS_ACTIVITY_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_BUSINESS_ACTIVITY_QUERY'),
  CATALOG_KUSPIT_BUSINESS_ACTIVITY_REPOSITORY: Symbol.for('CATALOG_KUSPIT_BUSINESS_ACTIVITY_REPOSITORY'),
  CATALOG_KUSPIT_BUSINESS_ACTIVITY_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_BUSINESS_ACTIVITY_STATE_MANAGER'),
};
